export default __webpack_public_path__ + "static/media/blog-34-image-2.7eeae634.jpg";